import Logout from "../pages/logout";

const CommonRoutes = {
  path: "/logout",
  element: <Logout />,
};

export default CommonRoutes;
